import React, { useEffect } from "react";
import PropTypes from "prop-types";
import useCartItem from "hooks/useCartItem";
import ImageViewer from "components/ImageViewer/ImageViewer";
import {
  classNameConditional,
  renderPriceWithSymbol,
} from "utils/commonMethods";
import CartActionButtons from "components/CartActionButtons/CartActionButtons";
import "components/ProductCards/CartProductCard/CartProductCard.css";
import { DeleteIcon, OfferIcon } from "constants/icons";
import useDiscount from "hooks/useDiscount";

function CartProductCard({ item, className = "" }) {
  const {
    itemQuantity,
    handleItemInCart,
    itemCategoryName,
    deleteItemFromCart,
    updateDiscountOfItem,
  } = useCartItem(item);

  const {
    applyDiscountMessage,
    discountPrice,
    discountTitle,
    discountSavingMessage,
  } = useDiscount(item);

  useEffect(() => {
    //Updates total discount for cart total.
    updateDiscountOfItem(item.sid, discountPrice);
  }, [discountPrice]);

  return (
    <div className={className}>
      <div className="cart-product-card outer-shadow">
        <div className="product__removal" onClick={deleteItemFromCart}>
          <i>
            <DeleteIcon />
          </i>
        </div>
        <div className="product-details">
          <div className="product-details--name ellipses">{item.name}</div>
          <div className="product-details--category">{itemCategoryName}</div>

          {/* <div className="product-details--price-quantity">
            {renderPriceWithSymbol(item.val) + " * " + itemQuantity}
          </div> */}
          {applyDiscountMessage && (
            <div className="product-details__apply-discount-message">
              {applyDiscountMessage}
            </div>
          )}
          {discountTitle && (
            <div className="product-details__discount-title">
              <i>
                <OfferIcon />
              </i>
              {discountTitle}
            </div>
          )}
          <div className="product-details__buy-price">
            {discountSavingMessage && (
              <div className="buy-price__saving-price-message">
                {discountSavingMessage}
              </div>
            )}
            {/* <div className="buy-price__overview">
              <span className="buy-price__final">
                {renderPriceWithSymbol(item.val * itemQuantity - discountPrice)}
              </span>
              {discountPrice > 0 && (
                <span className="buy-price__crossed">
                  {renderPriceWithSymbol(item.val * itemQuantity)}
                </span>
              )}
            </div> */}
          </div>
        </div>
        <div className="product__image-wrapper">
          <div className="product__image">
            <ImageViewer src={item.img} alt={item.name} />
          </div>
          <div className="cart-product-card__actions">
            {/* <CartActionButtons
              changeHandler={handleItemInCart}
              quantity={itemQuantity}
              className={classNameConditional(
                item.stk === itemQuantity,
                "text-muted"
              )}
            /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

CartProductCard.propTypes = {
  item: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default CartProductCard;
